<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h3>{{ 'app.not_found.page_not_found' | translate }}</h3>
      <h1><span>4</span><span>0</span><span>4</span></h1>
    </div>
    <h2>{{ 'app.not_found.page_not_found_1' | translate }}</h2>
  </div>
</div>
